import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Button from '../../UI/button/button';
import styles from './styles.module.scss';

function InsuranceTermsComponent({ handleShowTerms, withButton, handleClickButton, loading }) {
  const handleHideTermsClick = (e) => {
    e.preventDefault();
    handleShowTerms();
  };

  return (
    <div className={styles.insuranceTerms}>
      <div className={styles.content}>
        <div className={styles.termsTitle}>
          Temos e condições
          <FontAwesomeIcon icon={faTimesCircle} onClick={handleShowTerms} className={styles.closeIcon} />
        </div>
        <div className={styles.termsContent}>
          A contratação do seguro prestamista é opcional, a exclusivo critério do usuário, sendo facultado ao segurado o
          seu cancelamento a qualquer tempo, o qual implicará (i) suspensão e cancelamento das parcelas do prêmio
          vincendas e/ou (ii) devolução das parcelas do prêmio pagas relativas ao período posterior à data de
          cancelamento, conforme aplicável, sem a aplicação de quaisquer multas ou penalidades.
          <br />
          <br />
          Na hipótese de celebração de novos contratos de financiamento por usuário que houver contratado o seguro
          prestamista em relação a contrato de financiamento anteriormente celebrado, o usuário desde já autoriza a
          contratação do seguro prestamista em relação a tais novos contratos de financiamento, resguardado seu direito
          de cancelamento a qualquer tempo, nos termos acima.
          <br />
          <br />
          A não contratação do seguro prestamista não implicará qualquer alteração às condições comerciais da operação
          de crédito contratada.
          <br />
          <br />
          Em caso de contratação, o beneficiário será sempre o estipulante do seguro.
          <br />
          <br />
          Em caso de extinção antecipada da obrigação, o seguro estará automaticamente cancelado, devendo a seguradora
          ser formalmente comunicada, sem prejuízo, se for o caso, da devolução das parcelas do prêmio pagas relativas
          ao período posterior à extinção da obrigação, conforme aplicável.
          <br />
          <br />
          Para acionar a seguradora, ligue para o telefone abaixo, de acordo com a sua necessidade. SAC: 0800 702 9985,
          Horário de atendimento: 09:00 às 18:00 horas. Central de Atendimento: 0800 778 2052
          <br />
          <br />
          O segurado poderá consultar a situação cadastral de seu corretor de seguros, no site www.susep.gov.br, por
          meio do número de seu registro na SUSEP, nome completo, CNPJ ou CPF. O registro do plano na SUSEP não implica,
          por parte da autarquia, incentivo ou recomendação à sua comercialização. A comercialização do seguro é
          fiscalizada pela SUSEP - Superintendência Nacional de Seguros Privados. www.susep.gov.br. Telefone gratuito de
          atendimento ao público SUSEP: 0800 021 8484, Horário de Atendimento: segunda a sexta-feira, das 9h30 às 17h,
          exceto feriados. O segurado concorda e reconhece o direito da seguradora de solicitar, a qualquer momento,
          documentos / informações se assim forem necessárias. O segurado declara ter tomado conhecimento prévio e
          aceitado as condições gerais do seguro, inclusive, mas não exclusivamente, os riscos excluídos. Este seguro
          não tem a possibilidade de renovação após o término da sua vigência. As condições gerais do seguro
          encontram-se disponíveis no site: www.ezzeseguros.com.br ou www.susep.gov.br/menu/consulta-de-produtos-1.
          <br />
          <br />
          <a href="#" className={styles.termsCloseButton} onClick={handleHideTermsClick}>
            Fechar
          </a>
        </div>
      </div>
      {withButton && (
        <div className={styles.buttonWrapper}>
          <Button id="termsContractInsurance" onClick={handleClickButton} loading={loading} rounded>
            Contratar seguro agora
          </Button>
        </div>
      )}
    </div>
  );
}

export default InsuranceTermsComponent;
